<template>
  <div class="card card-body rounded-top">
    <component-table
      addButtonText="buttons.invite"
      entityType="team"
      addButtonPermissions="TEAM.UPDATE"
      :actions="actions"
      :addButtonEntityId="teamId"
      :hideSearchInput="true"
      :columns="columns"
      :data="list"
      :total="count"
      @add="showAddModal"
      @grantManagerPermissions="showGrantPermissionsDialog($event.id)"
    />

    <invite-modal :show="showModal" @save="invite" @close="hideModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import inviteModal from '@/components/modals/team/InviteModal';
import ComponentTable from '@/components/table/Table';
import { Members, MembersFunctionTranslation } from '@/enums/members.enum';
import { modalMixin } from '@/mixins/modal';
import { clubResource } from '@/resources/club.resource';
import { teamResource } from '@/resources/team.resource';
import { GRANT_MANAGER_PERMISSIONS_ACTION } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';
import { removeErrorPrefix } from '@/utils/string';

// @vuese
// Lista trenerów
// @group Team
export default {
  mixins: [modalMixin('team', {})],
  data() {
    return {
      actions: [{ ...GRANT_MANAGER_PERMISSIONS_ACTION, entityType: 'club', entityId: this.$route.params.clubId }],
      columns: [
        {
          name: 'firstName',
          displayName: 'columns.firstName'
        },
        {
          name: 'lastName',
          displayName: 'columns.lastName'
        },
        {
          name: 'phoneNumber',
          displayName: 'columns.phoneNumber'
        },
        {
          name: 'email',
          displayName: 'columns.email'
        }
      ]
    };
  },
  computed: {
    clubId() {
      return this.$route.params.clubId;
    },
    teamId() {
      return this.$route.params.teamId;
    },
    ...mapState({
      list(state) {
        return state.team.coach.list;
      },
      count(state) {
        return state.team.coach.count;
      }
    })
  },
  methods: {
    // @vuese
    // Wysyła zaproszenie do grupy treningowej
    invite(data) {
      teamResource[MembersFunctionTranslation[Members.COACH]](data.email, data.teamId)
        .then(() => this.$store.dispatch('notifySuccess', { title: 'messages.member.invite' }))
        .catch(() => this.$store.dispatch('notifyError', { title: 'messages.member.inviteError' }));
    },
    // @vuese
    // Otwiera okienko z potwierdzeniem nadania uprawnień menadżera klubu
    showGrantPermissionsDialog(email) {
      this.$store.dispatch('showConfirm', {
        title: this.$t('text.grant-permissions-dialog-title'),
        description: this.$t('messages.team.coach.grantManagerPermissionsConfirm'),
        onSuccess: () => this.grantManagerPermissions(email)
      });
    },
    // @vuese
    // Nadaje uprawnienia menadżera klubu
    grantManagerPermissions(profileId) {
      clubResource
        .clubAddManagerPermissions(profileId, tryParseInt(this.clubId))
        .then(() => this.$store.dispatch('notifySuccess', { title: 'messages.team.coach.grantManagerPermissions' }))
        .catch(err => {
          this.$store.dispatch('notifyError', {
            title: removeErrorPrefix(err?.message || err) || 'messages.team.coach.grantManagerPermissionsError'
          });
        });
    }
  },
  components: {
    ComponentTable,
    inviteModal
  }
};
</script>
